export default {
  common: {
    requests: 'Requests',
    request: 'Request',
    signUp: 'Aanmelden',
    logOut: 'Uitloggen',
    seeAll: 'Bekijk alle',
    follow: 'Volgen',
    unfollow: 'Ontvolgen',
    email: 'E-mail',
    fullName: 'Volledige naam',
    password: 'Wachtwoord',
    next: 'Volgende',
    addNew: 'Nieuwe toevoegen',
    type: 'Type',
    typeYourMessage: 'Schrijf je bericht',
    yourMessage: 'JE bericht',
    message: 'Bericht',
    shoutOut: 'Shoutout',
    story: 'Verhaal',
    chat: 'Chat',
    featureComingSoon: 'This feature is coming soon!',
    okay: 'Okay',
    send: 'Verzenden',
    delete: 'Verwijderen',
    cancel: 'Annuleren',
    search: 'Zoeken',
    back: 'Terug',
    goToHome: 'Ga naar huis',
    addShoutout: 'Shoutout toevoegen',
    player: 'Speler',
    text: 'Tekst',
    video: 'Video',
    comment: 'Opmerking',
    team: 'Team',
    country: 'Land',
    city: 'Stad',
    userName: 'Gebruikersnaam',
    following: 'Volgend',
    followers: 'Volgers',
    referals: 'Verwijzingen',
    athletes: 'Atleten',
    shoutouts: 'Shoutouts',
    showMore: 'Laat meer zien',
    showLess: 'Laat minder zien',
    sport: 'Sport',
    position: 'Positie',
    league: 'Liga',
    info: 'Info',
    repost: 'Opnieuw plaatsen',
    share: 'Delen',
    confirmed: 'Bevestigd',
    refused: 'Geweigerd',
    pending: 'In afwachting',
    canceled: 'Geannuleerd',
    trending: 'Populair',
    latest: 'Laatste',
    noData: 'Geen gegevens',
    from: 'van',
    to: 'naar',
    settings: 'Instellingen',
    areYouSure: 'Weet je het zeker',
    profile: 'Profiel',
    accept: 'Aanvaarden',
    refuse: 'Alles weigeren',
    missing: 'Ontbrekende',
    select: 'Selecteer',
    currency: 'Valuta',
    zipCode: 'Postcode',
    goBack: 'Ga terug',
    done: 'Gedaan',
    remove: 'Verwijderen',
    date: 'Datum',
    description: 'Beschrijving',
    amount: 'Bedrag',
    upload: 'Uploaden',
    getApp: 'Verkrijg de app',
    today: 'Vandaag',
    yesterday: 'Gisteren',
    tomorrow: 'Morgen',
    confirm: 'Bevestigen',
    confirmAll: 'Alles bevestigen',
    login: 'Inloggen',
    ad: 'AD',
    aboutUs: 'Over ons',
    fan: 'Fan',
    athlete: 'Atleet',
    stats: 'Statistieken',
    posts: 'Berichten',
    store: 'Winkel',
    or: 'Of',
    shoutout: 'Shoutout',
    proceed: 'Doorgaan',
    required: 'Vereist',
    dismiss: 'Afwijzen',
    save: 'Opslaan',
    discard: 'Weggooien',
    submit: 'Indienen',
    live: 'Live',
    openInbox: 'Open inbox',
    home: 'Home',
    searchDotDotDot: 'Zoeken...',
    reply: 'Antwoord',
    subscribers: 'Abonnees',
    subscribed: 'Geabonneerd',
    subscribe: 'Aanmelden',
    unsubscribe: 'Uitschrijven',
    fans: 'Fans',
    teams: 'Teams',
    setup: 'Opgericht',
    feed: 'Voer',
    messages: 'Berichten',
    earlier: 'Eerder',
    apply: 'Toepassen',
    oneOnOnes: 'Een-op-een',
    sort: 'Sorteer',
    comingSoon: 'Binnenkort beschikbaar',
    goLive: 'Ga leven',
    total: 'Totaal:',
    pay: 'Betaal {{amount}}',
    free: 'gratis',
    location: 'Locatie',
    countries: 'Landen',
    more: 'meer',
    less: 'minder',
    block: 'Blokkeren',
    unblock: 'Deblokkeren',
    privacyPolicy: 'Privacybeleid',
    termsAndConditions: 'Voorwaarden',
    createNew: 'Nieuw maken',
    game: 'Spel',
    unlock: 'Ontgrendel',
    post: 'Post',
    uploadFile: 'Bestand uploaden',
    checkIn: 'Inchecken'
  },
  sports: {
    americanFootball: 'American football',
    baseball: 'Honkbal',
    basketball: 'Basketbal',
    boxing: 'Boksen',
    cricket: 'Cricket',
    soccer: 'Voetbal',
    mma: 'MMA',
    race: 'Autosport ',
    tennis: 'Tennis',
    carRace: 'Raceauto rijden',
    acrobatics: 'Acrobatiek',
    airSports: 'Luchtsporten',
    archery: 'Boogschieten',
    combatSports: 'Vechtsporten',
    cycling: 'Wielersport',
    cueSports: 'Cue sporten',
    equestrianSports: 'Paardensport',
    golf: 'Golf',
    handball: 'Handbal',
    iceSports: 'Ijs Sporten',
    lacrosse: 'Lacrosse',
    polo: 'Polo',
    weightlifting: 'Gewichtheffen',
    rowing: 'Roeien',
    softball: 'Softbal',
    rugby: 'Rugby',
    volleyball: 'Volleybal',
    coachingMentoring: 'Coachen, lesgeven',
    figureSkating: 'Figuurschaatsen',
    formula1: 'Formule 1',
    gymnastics: 'Gymnastiek',
    hockey: 'Hockey',
    kickboxing: 'Kickboksen',
    motorSports: 'Motorsporten',
    muayThai: 'Muay Thai',
    olympics: 'Olympische Spelen',
    poleSports: 'Paal sporten',
    sportsInfluencer: 'Sport Beïnvloeder',
    swimming: 'Zwemmen',
    trackField: 'Atletiek en veld',
    visualArtist: 'Visuele artiest',
    wheelchairRugby: 'Rolstoelrugby',
    wrestling: 'Worstelen',
    iceHockey: 'IJshockey',
    alpineSkiing: 'Alpineskiën',
    flagFootball: 'Vlaggenvoetbal',
    climbing: 'Klimmen',
    badminton: 'Badminton',
    motorcycleRacing: 'Motorracen'
  },
  levels: {
    interested: 'Geïnteresseerd',
    beginner: 'Beginner',
    amateur: 'Amateur',
    intermediate: 'Intermediair',
    expert: 'Expert',
    retired: 'Gepensioneerd'
  },
  auth: {
    signUpFacebook: 'Aanmelden met Facebook',
    signUpGoogle: 'Aanmelden bij Google',
    signUpPaypal: 'Aanmelden met PayPal',
    forgottenPassword: 'Je wachtwoord vergeten?',
    logInFacebook: 'Inloggen met Facebook',
    logInGoogle: 'Inloggen met Google',
    logInPaypal: 'Inloggen met PayPal',
    dontHaveAccount: 'Heb je geen account?',
    mustContain8Characters: 'Moet minimaal 8 karakters bevatten.',
    alreadyHaveAccount: 'Heb je al een account?',
    passwordReset: 'Wachtwoord opnieuw instellen',
    resetInstructions:
      'Voer het e-mailadres in dat bij je account hoort, en wij sturen de instructies voor het herstel van het wachtwoord.',
    sendRecoveryEmail: 'Herstelmail versturen',
    backTo: 'Terug naar',
    logIn: 'Inloggen',
    checkEmail: 'Controleer uw e-mailadres',
    noAccount: 'Er is geen account gekoppeld',
    pleaseTryAnother: 'Probeer een ander adres.',
    tryAnother: 'Probeer een andere e-mail',
    emailSent: 'Herstel-e-mail verzonden',
    checkEmailInstructions:
      'Controleer je inbox (en spamfolders) om de instructies te vinden en te volgen om je e-mail te valideren.',
    createNewPassword: 'Nieuw wachtwoord aanmaken',
    newPassword: 'Nieuw wachtwoord',
    confirmPassword: 'Wachtwoord bevestigen',
    resetPassword: 'Wachtwoord opnieuw instellen',
    validateYourEmail: 'Valideer uw e-mail',
    validateEmailInstructions:
      'We hebben je nodig om je e-mail te valideren om je nieuwe P4P account te activeren.',
    confirmEmail: 'Bevestig e-mail',
    validationEmailSent: 'Verzonden validatie e-mail',
    checkInboxToValidateEmail:
      'Controleer je inbox (en spamfolders) om de instructies te vinden en te volgen om je e-mail te valideren.',
    getTheApp: 'Download de app',
    accountLocked: 'Je account is geblokkeerd',
    accountLockedDesc:
      'We houden alles veilig en hebben je account geblokkeerd vanwege te veel pogingen met verkeerde gegevens. Controleer je inbox om het wachtwoord opnieuw in te stellen.',
    checkInbox: 'Controleer mijn inbox',
    youAcceptTerms:
      'Door te registreren of in te loggen, gaat u akkoord met onze Algemene voorwaarden en ons Privacybeleid.',
    logInApple: 'Inloggen met Apple',
    signUpApple: 'Aanmelden bij Apple'
  },
  messages: {
    newMessages: 'Nieuwe berichten',
    newGroup: 'Nieuwe groep',
    favorites: 'Favorieten',
    favoritesAtTop: 'Favorieten bovenaan',
    favoritesOnly: 'Alleen favorieten',
    excludeHidden: 'Verborgen uitsluiten',
    showHidden: 'Verborgen weergeven',
    hiddenChats: 'Verborgen chats',
    message: 'Bericht',
    addChat: 'Chat toevoegen',
    searchFriends: 'Vrienden zoeken',
    createdGroup: '{{group}} heeft deze groep gemaakt',
    totalMessageSingular: '1 Nieuw bericht',
    totalMessages: '{{totalMessageCount}} Nieuwe berichten',
    noChats: 'Geen chats beschikbaar.',
    noChatSelected: 'Geen chat geselecteerd.',
    messageDotDotDot: 'Bericht...',
    noChatYet: 'Nog geen chat hier...',
    searchFriendsGroups: 'Vrienden of groepen zoeken...',
    selectFriend: 'Selecteer vriend',
    groupChatName: 'Naam groepschat',
    startChat: 'Chat starten',
    youNeedSub: 'Je moet je abonneren op {{name}} om een bericht te kunnen sturen',
    youBlocked: 'Je hebt deze gebruiker geblokkeerd'
  },
  home: {
    latestPosts: 'Laatste berichten',
    confirmed: 'Bevestigd',
    playazRunsSafeEnvironment: 'Playaz zorgt voor een veilige omgeving',
    connectionsConverstationsFollowedAthletes:
      'Gelijkgestemde connecties om gesprekken te voeren, groepsontmoetingen, en te leren van je gevolgde atleten.',
    myPosts: 'Mijn berichten',
    accountsToFollow: 'Rekeningen volgen',
    comingUp: 'Binnenkort',
    gloriousWinners: 'Glorieuze winnaars',
    todaysGames: 'Spelletjes van vandaag',
    athleteHighlights: 'Hoogtepunten van atleten',
    fanHighlights: 'Hoogtepunten voor fans',
    todaysMatches: 'Matches vandaag'
  },
  add: {
    followers: 'Volgers',
    subscribers: 'Abonnees',
    onlyMe: 'Alleen ik',
    photoVideo: "Foto's/Video's",
    tag: 'Tag',
    editMedia: 'Media bewerken',
    tapCrop: 'Tik op een afbeelding om bij te snijden.',
    gallery: 'Galerij',
    addMultiple: 'Meerdere toevoegen',
    shoutOutTo: 'Shout out naar',
    whereItHappens: 'Waar het gebeurt',
    shouldAcceptTerms: 'Je moet de algemene voorwaarden accepteren',
    summary: 'Samenvatting',
    total: 'Totaal:',
    iAcceptTerms:
      'Volgens de algemene voorwaarden ga ik ermee akkoord dat het hierboven vermelde bedrag in rekening wordt gebracht bij de bevestiging van de atleet',
    post: 'Post',
    enterYoutubeLink: 'Voer Youtube link in',
    tagFriends: 'Vrienden taggen',
    shareWith: 'Delen met',
    everyone: 'Iedereen',
    peopleFollowBack: 'Alleen mensen die ik terugvolg',
    linkToVideo: 'Link naar video',
    swipeRightPurchase: 'Veeg naar rechts om te kopen',
    uploadMedia: 'Media uploaden',
    shareLink: 'Deel link',
    correctYoutubeLink: 'Voeg een correcte Youtube link toe.',
    writeCaption: 'Schrijf een onderschrift',
    selectionsWillRemove:
      'Je kunt maar één video plaatsen, andere selecties worden verwijderd. Doorgaan?',
    selectVideo: 'Selecteer video',
    onlySingleVideo: 'Je kunt voorlopig maar één video plaatsen.',
    upToAMinutes: 'De video mag maximaal 1 minuut lang zijn.',
    text: 'Tekst',
    video: 'Video',
    tagPeople: 'Tag mensen',
    enterLink: 'Link invoeren',
    linkToOriginalPost: 'Link naar origineel bericht',
    pasteForPreview: 'Plak de link om het voorbeeld van de post te zien',
    createPost: 'Maak post...',
    recent: 'Recente',
    noUserFound: 'Geen gebruikers gevonden met de overeenkomende criteria',
    searchResults: 'Zoekresultaten',
    storyPublished: 'Verhaal gepubliceerd!',
    live: 'Live',
    shoutout: 'Shoutout',
    addPhotosAndVideos: "Foto's en video's toevoegen",
    addLocation: 'Locatie toevoegen',
    onlyForSubscribers: 'Alleen voor abonnees',
    photosAndVideos: "Foto's en video's",
    selectUpTo10: 'Selecteer tot 10',
    suggested: 'Aanbevolen',
    shoutoutTo: 'Shoutout naar {{name}}',
    createShoutout: 'Shoutout maken',
    newShoutout: 'Nieuwe shoutout',
    tapOrHold: 'Tikken voor foto, ingedrukt houden voor video',
    tapGoLive: 'Tikken voor live gaan',
    addNewPost: 'Nieuwe post toevoegen',
    addNewShoutout: 'Shoutout toevoegen',
    fileFormats: 'JPEG-, PNG-, MP4-, WebM- of Ogg-bestandsindelingen',
    create: 'Creëren',
    correctLink: 'Voeg een correcte link toe.',
    teamOrPlayer: 'Team of speler',
    createNewShoutout: 'Maak een nieuwe Shoutout',
    createNewPost: 'Maak een nieuwe post'
  },
  browse: {
    trySearchAthlete: 'Probeer te zoeken naar een atleet, team of een hashtag',
    basedYourPreferences:
      'Op basis van je voorkeuren, hier zijn enkele atleten en fans die je misschien leuk vindt om te volgen.',
    erlingHaaland: 'Erling Haaland',
    parisSaintGermain: 'Paris Saint-Germain',
    trendingPosts: 'Actuele berichten',
    chooseSportAndFavoriteTeam:
      'Kies sporten en kies je favoriete team van atleten om je op de hoogte te houden.',
    trendingTeams: 'Trending teams',
    seeTeamsYourFellow: 'Bekijk teams die je medefans en atleten op dit moment volgen.',
    atalanta: 'Atalanta',
    serieaFootballClub: 'Serie A Voetbalclub',
    browse: 'Bladeren',
    athletesOnPlatform: 'Atleten op P4P',
    fansOnPlatform: 'Fans op P4P',
    upcomingEvents: 'Aankomende evenementen',
    eventsComingUpYourFavorite:
      'Komende evenementen gebaseerd op je favoriete sporten, teams en atleten.',
    superBantamweight: 'Super Bantamgewicht',
    tiffanyVanSoestAlinePereira: 'Tiffany van Soest - Aline Pereira',
    chicagoVenue: 'Chicago, Chicago Locatie',
    suggestedAthletes: 'Voorgestelde atleten',
    suggestedFans: 'Voorgestelde fans',
    suggestedAccounts: 'Voorgestelde accounts',
    newAppHasArrived: 'Onze nieuwe app is gearriveerd!',
    newAppDesc:
      'We hebben je P4P-ervaring toegevoegd met je feedback. Geniet van de bijgewerkte APP en blijf op de hoogte voor verdere updates.',
    seeTheApp: 'Bekijk de APP',
    postCountSingular: '1 bericht',
    postCountPlural: '{{count}} berichten',
    recent: 'Recent',
    top: 'Boven',
    athletes: 'Atleten',
    teams: 'Teams',
    tags: 'Tags',
    fans: 'Fans',
    trendingShoutouts: 'Trending shoutouts',
    goBrowse: 'Ga bladeren',
    follower: 'volger',
    followers: 'volgers',
    todaysGames: 'Spelletjes van vandaag',
    trendingAthletes: 'Trending atleten',
    trendingFans: 'Populaire fans',
    allAthletes: 'Alle atleten',
    allFans: 'Alle fans',
    sortBy: 'Sorteren op',
    name: 'Naam',
    popularity: 'Populariteit',
    recentlyRegistered: 'Onlangs geregistreerd',
    filterByConnection: 'Filter op verbinding',
    showAll: 'Alles weergeven',
    showOnlyConnect: 'Toon alleen sporters die je kunt verbinden',
    teamsOnPlatform: 'Teams op P4P',
    allTeams: 'Alle teams',
    todaysMatches: 'Matches vandaag'
  },
  chat: {
    muteNotifications: 'Meldingen dempen',
    removeFavorites: 'Verwijderen uit favorieten',
    addFavorites: 'Toevoegen aan favorieten',
    clearChatHistory: 'Verwijder chatgeschiedenis',
    youCannotAction: 'Je kunt deze actie niet ongedaan maken.',
    deleteConversationWith: 'Gesprek verwijderen met ',
    deleteConversation: 'Gesprek verwijderen',
    unhideChat: 'Chat zichtbaar maken',
    hideChat: 'Chat verbergen',
    clearHistory: 'Geschiedenis wissen',
    noResults: 'Geen resultaten...',
    noMessagesYet: 'Nog geen berichten hier...',
    returnChat: 'Terug naar de chat',
    searchMessages: 'Berichten zoeken...',
    clearConfirmation: 'Weet je zeker dat je deze chat wilt wissen?',
    deleteConfirmation: 'Weet je zeker dat je deze chat wilt verwijderen?',
    block: 'Blokkeren',
    disableSound: 'Geluid uitschakelen',
    muteNotificationsFor: 'Meldingen dempen voor...',
    thirtyMinutes: '30 minuten',
    oneHour: '1 uur.',
    oneDay: '1 dag',
    oneWeek: '1 week',
    oneMonth: '1 maand',
    muteForever: 'Voor altijd dempen'
  },
  comments: {
    succesfullyReactedPost: 'Met succes gereageerd op dit bericht.',
    beFirstReaction: 'Reageer als eerste',
    comments: 'Opmerkingen',
    noComments: 'Geen commentaar',
    comment: 'Opmerking'
  },
  connect: {
    endOneOnOneWith: 'Eindig een-op-een met ',
    youWontGoBackCall: 'Je kunt niet meer terug naar dit betaalde gesprek.',
    sayGoodBye: 'Gedag zeggen tegen',
    timeToWrapUp: 'Tijd om af te ronden',
    oneOnOneCall: 'Een-op-een gesprek',
    setupConnect: 'Een-op-een verbinding instellen'
  },
  connectConfirmations: {
    cancelOneOnOne: 'Een-op-een annuleren',
    unfortunatelyCanceled: 'Helaas is je een-op-een verbinding met {{name}} geannuleerd.',
    timeToStart: 'Het is tijd om je geboekte 15 minuten een-op-een te beginnen met {{name}}',
    swipeCancel: 'Veeg naar rechts om de verbinding te annuleren',
    wantCancelOneOnOne: 'Wil je de een-op-een annuleren? ',
    youWillPay: 'Dit kan niet ongedaan worden gemaakt en u betaalt annuleringskosten ({{bedrag}})',
    fanWillGet:
      'Dit kan niet ongedaan worden gemaakt en de fan krijgt 100% restitutie ( {{amount}} )',
    swipeRightStart: 'Veeg naar rechts om verbinding te maken',
    oneOnOneConnectEnded: 'Een-op-een verbinding beëindigd',
    '15minCall':
      'Je 15 minuten gesprek met {{name}}, en we hopen dat je een prettig gesprek hebt gehad met je favoriete atleet.',
    bookAnotherOneOnOne: 'Boek nog een een-op-een',
    refuseOneOnOne: 'Een-op-een weigeren',
    wantRefuseOneOnOne: 'Wil je de één-op-één weigeren met {{name}}',
    swipeRightRefuseConnect: 'Veeg naar rechts om verbinding te weigeren',
    '15minCallWithAthlete':
      'Je gesprek van 15 minuten met {{name}} , en we hopen dat je een spannend gesprek hebt gehad met je favoriete sporter.',
    waitingInLobby: 'Wachten in de lobby...',
    pleaseWaitUser: 'Wacht tot je een-op-een met <strong> {{name}} </strong> begint.',
    refusedOneOnOneConnect: 'Weigerde één-op-één contact',
    callSettings: 'Belinstellingen:'
  },
  settings: {
    referAnAthlete: 'Verwijs een atleet door',
    upgradePlan: 'Upgrade plan',
    settings: 'Instellingen',
    changePassword: 'Wachtwoord wijzigen',
    oldPassword: 'Oud wachtwoord',
    newPassword: 'Nieuw paswoord',
    privacyAndSecurity: 'Privacy en beveiliging',
    profilePrivacySettings: 'Profiel privacy-instellingen',
    whoCanView: 'Wie kan je profielpagina bekijken?',
    whoCanViewInfo: 'Wie kan het infotabblad op uw profielpagina bekijken?',
    whoCanViewBasicInfo: 'Wie kan je basisinformatie bekijken?',
    whoCanViewLocation: 'Wie kan uw locatie bekijken?',
    whoCanViewActivities: 'Wie kan je activiteitensectie op je profielpagina bekijken?',
    whoCanShare: 'Wie kan een bericht op je prikbord delen?',
    whoCanViewFriends: 'Wie kan de lijst met vrienden bekijken?',
    whoCanSendFriends: 'Wie kan mij een vriendschapsverzoek sturen?',
    whoCanSendMessage: 'Wie kan je een bericht sturen?',
    whoCanViewPhotos: "Wie kan foto's op je profielpagina bekijken?",
    whoCanPokes: 'Wie kan pokes sturen?',
    whoCanViewViewed: 'Wie kan zien wie onlangs je profiel heeft bekeken?',
    whoCanTag: 'Wie kan mij taggen in geschreven contexten?',
    whoCanSeeDateOfBirth: 'Wie kan je geboortedatum zien?',
    allowSharing: 'Sta delen van toe',
    allowMentions: 'Laat vermeldingen toe van',
    allowTags: 'Tags toestaan van',
    avilabilityPeriod: 'Beschikbaarheidsperiode',
    pleaseShare:
      'Deel je maandelijkse inkomstenverwachtingen. Fans zullen dit niet zien in je profiel.',
    customPeriod: 'Aangepaste periode...',
    from: 'Van',
    to: 'Naar',
    selectStart: 'Selecteer startdatum',
    selectEnd: 'Selecteer einddatum',
    total: 'Totaal',
    pendingRequest: 'Openstaande verzoeken',
    invalid: 'ongeldig',
    today: 'Vandaag',
    months: 'Maanden',
    weeks: 'Weken',
    setAvailability: 'Beschikbaarheid instellen',
    fansWillOnly: 'Fans kunnen alleen een een-op-een boeken binnen de beschikbare slots',
    period: 'Periode',
    dayOfTheWeek: 'Dag van de week',
    daily: 'Dagelijks',
    thisWeek: 'Deze week',
    thisMonth: 'Deze maand',
    availableTime: 'Beschikbare tijd',
    time: 'Tijd',
    timeBetween: 'Tijd tussen aansluitingen',
    breakDuration: 'Duur van de pauze',
    setAvailableTime: 'Stel de beschikbare tijd in van',
    chooseATime: 'Kies een tijdstip gedurende de dag waarop je één-op-één verzoeken wilt krijgen',
    weekDays: 'Doordeweekse dagen',
    weekends: 'weekenden',
    oneOnOneConnect: 'Een-op-een verbinding',
    save: 'Opslaan',
    search: 'Zoeken',
    subscriptions: 'Abonnementen',
    emailNotifications: 'E-mail notificaties',
    languageAndCurrency: 'Taal & valuta',
    theme: 'Thema',
    billing: 'Facturering',
    accessBilling: 'Toegang tot factureringsgegevens',
    logOut: 'Uitloggen',
    countryCode: 'Landnummer',
    selectCountry: 'Selecteer land',
    passwordChangeSuccessful: 'U heeft met succes uw wachtwoord bijgewerkt.',
    confirmNewPassword: 'Bevestig nieuw wachtwoord',
    forgotPassword: 'Wachtwoord vergeten?',
    enableEmailNotifications: 'Schakel e-mailmeldingen in',
    newComments: 'Nieuwe opmerkingen',
    newTags: 'newTags',
    newSubscriptions: 'Nieuwe abonnementen',
    newFriends: 'Nieuwe vrienden',
    friendRequests: 'Vriendschapsverzoeken',
    notificationForLikes: 'Melding voor "Vind ik leuk"',
    newMessages: 'Nieuwe berichten',
    photosNotifications: "Meldingen over foto's",
    language: 'Taal',
    currency: 'Valuta',
    anyone: 'Iedereen',
    community: 'Gemeenschap',
    friendsOnly: 'Alleen vrienden',
    noOne: 'Niemand',
    onlyAvailableViaApp: 'Alleen beschikbaar via mobiele APP',
    darkMode: 'Donkere modus',
    contentPrivacySettings: 'Privacy-instellingen voor inhoud',
    setAvailableTimeTo: 'Stel beschikbare tijd in op',
    chooseATimeTo:
      'Kies een tijdstip gedurende de dag waarop je één-op-één verzoeken wilt krijgen om',
    removeAccount: 'Account verwijderen',
    accountPrivacy: 'Rekening'
  },
  scheduleConnect: {
    '15minutesCall': '15 minuten gesprek',
    thereIsNo: 'Er is geen beschikbaarheid voor deze datum.',
    selectTime: 'Selecteer tijd',
    bookOneOnOne: 'Boek een-op-een',
    youAlreadyHave: 'Je hebt al een connectie met deze sporter.',
    scheduleAlreadyExist: 'Schema bestaat al',
    ad: 'ADVERTENTIE',
    nextAvailableSlot: 'Volgende beschikbare slot',
    noScheduleFound: 'Geen schema gevonden',
    thisUserHasnt: 'Deze gebruiker heeft zijn agenda nog niet ingesteld. Kom later terug.',
    schedule: 'Schema',
    today: 'Vandaag',
    tomorrow: 'Morgen',
    weeks: 'Weken',
    seeCalendar: 'Zie kalender',
    dateAndTime: 'Datum en tijd',
    edit: 'Bewerken',
    total: 'Totaal:',
    asPerTheTerms:
      'Volgens de algemene voorwaarden ga ik ermee akkoord dat het hierboven vermelde bedrag in rekening wordt gebracht bij de bevestiging van de atleet',
    sendRequest: 'Stuur verzoek',
    oneOnOneRequest: 'Een-op-een verzoek verzonden',
    afterTheAthleteAccepts:
      'Nadat de atleet je verzoek heeft geaccepteerd, ontvang je een melding en zie je de lopende een-op-een terug in het dashboard.',
    goToDashboard: 'Ga naar het dashboard',
    bookOtherOneOnOne: 'Boek andere een-op-een',
    proceed: 'Doorgaan',
    searcAthletes: 'Zoek atleten',
    notVerified: 'Dit profiel is geen geverifieerde atleet.',
    bookOneOnOneTeam: 'Booking a Face2Face? Please select your favorite athlete. Thank you!',
    noBooked: 'Je hebt nog geen Face2Face geboekt',
    bookedYet: 'Heb je al een een-op-eengesprek geboekt?',
    selectDay: 'Selecteer dag',
    nextOneOnOnes: 'Volgende één-op-één',
    noResults:
      'Al onze atleten hebben een vol schema. Er zijn regelmatig plaatsen vrij, dus kom later nog eens terug.'
  },
  connectsDashboard: {
    byFan: 'DOOR FAN',
    byAthlete: 'DOOR ATLEET',
    pending: 'In afwachting van',
    confirmed: 'Bevestigd',
    rejected: 'Afgekeurd',
    timeBooked: 'Geboekte tijd',
    refuseOneOnOneConnect: 'Weiger alle een-op-een verbindingen voor ',
    refuseAll: 'Weiger alle',
    oneOnOneConnect: 'Een-op-een verbinding',
    bookAgain: 'Boek opnieuw'
  },
  dashboard: {
    monthlyTarget: 'Maandelijkse doelstelling',
    setMonthlyRevenueTarget: 'Je hebt je maandelijkse omzetdoel nog niet vastgesteld.',
    useAthleteRefferalCodes: 'Gebruik verwijzingscodes voor atleten om het team te laten groeien',
    setupRateAndAvailability:
      'Stel tarief en beschikbaarheid op om één-op-één verzoeken te krijgen.',
    shoutouts: 'Shoutouts',
    vipConnect: 'VIP Connect',
    week: 'Week',
    month: 'Maand',
    year: 'Jaar',
    all: 'Alle',
    custom: 'Aangepast...',
    total: 'Totaal',
    dashboard: 'Dashboard',
    referrals: 'Verwijzingen',
    income: 'Inkomen',
    users: 'Gebruikers',
    subscribed: 'Geabonneerd',
    progress: 'Voortgang',
    followers: 'Volgers',
    advertising: 'Reclame',
    views: 'Weergaven',
    number: 'Nummer',
    athleteEmail: 'Atleet e-mail',
    meetings: 'Vergaderingen',
    itemsSold: 'Verkochte artikelen',
    store: 'Winkel',
    editMonthlyTarget: 'Maandelijkse doelstelling wijzigen',
    inviteToGrow: 'Typ een uitnodigings e-mail om het team te laten groeien.',
    inviteAthletes: 'Atleten uitnodigen',
    follower: 'Volgers'
  },
  editProfile: {
    sport: 'Sport',
    selectSuport: 'Selecteer Sport',
    favoriteTeam: 'Favoriete team',
    selectTeam: 'Selecteer team',
    favoritePlayer: 'Favoriete atleet',
    selectPlayer: 'Selecteer speler',
    addMoreSport: 'Meer sport toevoegen',
    editProfile: 'Profiel bewerken',
    dateOfBirth: 'Geboortedatum',
    bio: 'Bio',
    mySport: 'Mijn sport',
    mySports: 'Mijn sporten',
    position: 'Positie',
    selectPosition: 'Selecteer positie',
    level: 'Niveau',
    selectLevel: 'Selecteer niveau',
    personalInformation: 'Persoonlijke informatie',
    myGender: 'Mijn geslacht',
    female: 'Vrouw',
    male: 'Man',
    other: 'Andere',
    imFrom: 'Ik kom uit',
    yourPhoneNumber: 'Jouw telefoon nummer'
  },
  profile: {
    wantToConnect: 'Wil je face-to-face contact opnemen?',
    favoriteSports: 'Favoriete sporten',
    favoriteAthlete: 'Favoriete atleet',
    referAndReward: 'Beloon jezelf door een atleet door te verwijzen',
    invitePeople: 'Mensen uitnodigen',
    earnMoreReferralFees: 'Verdien meer "referral fees" door atleten om je heen uit te nodigen',
    inviteAthleteFan: 'Nodig sporters en fans uit',
    typeEmailToInvite: 'Typ e-mail om een uitnodiging te sturen om het team te laten groeien.',
    athleteEmail: 'Atleet e-mail',
    doesntExists: 'Deze gebruiker bestaat niet.',
    latestShoutouts: 'Laatste shoutouts',
    mySports: 'Mijn sporten',
    myEquipment: 'Mijn uitrusting',
    relatedProducts: 'Verwante producten',
    bidForEquipment: 'Bied op mijn uitrusting',
    goToAppSettings: 'Ga naar APP instellingen',
    recentShoutouts: 'Recente shoutouts',
    recentUpdates: 'Recente updates',
    trendingPosts: 'Trending berichten',
    following: 'Volgend',
    userNotFound: 'Gebruiker @{{username}} niet gevonden',
    searchFriendsAndFollowers: 'Vrienden en volgers zoeken',
    noUpdatesYet: '{{name}} heeft nog geen updates',
    noPostsYet: '{{name}} heeft nog niet gepost',
    followToKnowFirst:
      'Volg {{name}} om als eerste op de hoogte te zijn van updates zoals podcasts of live streaming.',
    encourage: 'Voel je vrij om ze een shout-out te sturen om ze aan te moedigen.',
    threeMonthsAccess: 'Je hebt drie maanden onbeperkte toegang achter gesloten deuren',
    enjoyFreeAccess: 'Geniet van de exclusieve content van de atleten.',
    repostHeader:
      '<strong> {{owner}} </strong> heeft <strong> {{originalOwner}} </strong> bericht gedeeld',
    nowFollowing: 'Volgt nu {{name}}',
    sureToRemove: 'Weet je zeker dat je je account wilt verwijderen? Deze actie is onomkeerbaar.',
    getUnlimited: 'Ontvang onbeperkte inhoud',
    getUnlimitedDesc:
      'Abonneer je op je favoriete atleet om op de hoogte te blijven van exclusieve content.',
    verifiedAthlete: 'Geverifieerde atleet'
  },
  notifications: {
    notifications: 'Meldingen',
    comingUpConnect: 'Over vijf minuten één-op-één met {{sender}}',
    connectRequest: 'Een-op-een verzoek van {{sender}}',
    connectStatus: '{{status}} een-op-een met {{sender}}',
    connectStarting: 'Het is tijd om je geboekte 15 minuten een-op-een te beginnen met {{sender}}',
    commentedToPost: 'reageerde op je bericht',
    commentedToSportChat: '<strong>{{sender}}</strong> \ncommented on your sport chat',
    reactedToPost: 'reageerde op je shoutout',
    reactedToShoutout: 'reageerde op je shoutout',
    amountReactedToPost: '{{amount}} mensen hebben op je bericht gereageerd',
    aNewShoutout: 'Je hebt een nieuwe shoutout',
    newShoutouts: 'Je hebt {{amount}} nieuwe shoutouts',
    shoutoutReaction: '{{sender}} reageerde op je shoutout',
    startedFollowing: '{{sender}} begon je te volgen',
    amountStartedFollowing: '{{amount}} gebruikers volgen je nu',
    newSub: 'Je hebt een nieuwe abonnee',
    newSubs: 'Je hebt {{amount}} nieuwe abonnees',
    newRequests: '{{amount}} nieuwe een-op-een verzoeken',
    newFollower: 'volgde je',
    taggedInPost: '<strong> {{sender}} <\/strong>\n hebben je getagd in hun bericht',
    mentionedInPost: '<strong>{{sender}}</strong> \nnoemde je in hun bericht',
    commentTagged: '<strong>{{sender}}</strong> \ntagde jou in hun commentaar',
    p4pMonetizingYourBrand: 'P4P is Monetizing Your Brand!',
    fanRequestingShoutout: 'A Fan is Requesting a Shoutout.',
    view: 'View',
    congratulations: 'Congratulations!',
    yourFavoriteAthleteCompletedYourRequest: 'Your favorite athlete has completed your shoutout.',
    sorryFavoriteAthleteCurrentlyUnavailable:
      'Sorry your favorite athlete is currently unavailable. Please try again later or select another player.',
    sportChatCommentTagged: '<strong>{{sender}}</strong> \ntagged you in their sport chat comment',
    startedSubscribing: '<strong>{{sender}}</strong> \nis nu op jou geabonneerd'
  },
  repost: {
    tagFriends: 'Vrienden taggen',
    repost: 'Opnieuw plaatsen',
    create: 'Creëren',
    yourComment: 'Je commentaar',
    shareWith: 'Delen met',
    everyone: 'Iedereen',
    OnlyPeopleIFollowBack: 'Alleen mensen die ik volg'
  },
  onBoarding: {
    everybody: 'IEDEREEN',
    plays: 'SPEELT',
    better: 'BETER',
    together: 'SAMEN.',
    favoriteSports: 'Favoriete sporten',
    chooseSports: 'Kies sporten en je favoriete team van atleten om je op de hoogte te houden.',
    selectSport: 'Selecteer sporten',
    sport: 'Sport',
    favoriteTeam: 'Favoriete Team',
    selectTeam: 'Selecteer team',
    favoritePlayer: 'Favoriete speler',
    selectPlayer: 'Selecteer speler',
    addMoreSport: 'Meer sporten toevoegen',
    getStarted: 'Aan de slag',
    youreAlmostThere: 'Je bent er bijna',
    tellUsAboutYourself:
      'Vertel ons over jezelf om de meest belangrijke feeds en updates te krijgen.',
    imFrom: 'Ik kom uit',
    yourPhoneNumber: 'Je telefoonnummer',
    dateOfBirth: 'Geboortedatum',
    monthlyRevenueTarget: 'Doelstelling maandelijkse inkomsten',
    pleaseShareYour: 'Deel je maandelijkse omzetverwachtingen. Fans zien dit niet in je profiel.',
    next: 'Volgende',
    skipThisStep: 'Sla deze stap over',
    yourSports: 'Jouw sporten',
    chooseASport: 'Kies een sport en kies je positie.',
    mySport: 'Mijn sport',
    position: 'Positie',
    selectPosition: 'Selecteer Positie',
    addSecondarySport: 'Tweede sport toevoegen',
    chooseSportsYou: 'Kies sporten waarin je geïnteresseerd bent.',
    skipAndGet: 'Sla over en ga aan de slag',
    connectDirectlyWith:
      'Bouw je eigen wereld op door rechtstreeks contact te leggen met atleten - het echte werk.',
    monetizeYourBrand: 'Verdien geld met je merk door een unieke wereld te creëren met je fans.',
    chooseAUsername: 'Kies een gebruikersnaam',
    referralCodeOptional: 'Verwijzingscode (optioneel)',
    backTo: 'Terug naar',
    logIn: 'Inloggen',
    imAFan: 'Ik ben een fan',
    imAnAthlete: 'Ik ben een atleet',
    createAnAccount: 'Maak een account aan',
    searchTeams: 'Zoekteams'
  },
  shoutout: {
    comingSoon: 'Shoutout komt eraan',
    comingSoonDesc:
      'Communiceer met beroemde atleten wereldwijd en stuur motiverende en positieve shoutouts.',
    success: 'Shoutout succesvol verzonden.',
    selectTeamOrAthete: 'Selecteer een Team of Atleet',
    teamOrAthlete: 'Team/Atleet',
    writeShoutout: 'Schrijf een shoutout',
    createMatchDayShoutout: 'Maak een Wedstrijddag-Shoutout',
    matchDayShoutouts: 'Wedstrijddag Shoutouts',
    shoutoutsFromAthletes: 'From Athletes',
    shoutoutsFromFans: 'From Fans'
  },
  shop: {
    comingSoon: 'Winkel komt eraan',
    comingSoonDesc:
      'Merchandise van je favoriete beroemde atleten, kaartjes voor evenementen, exclusieve aanbiedingen en meer zijn verkrijgbaar via onze gezellige winkel. We zullen je spoedig informeren over de opening.'
  },
  header: {
    logOutConfirmation: 'Uitloggen van je account? Je kunt later inloggen met jou inloggegevens.',
    upgradePlan: 'Upgradeplan'
  },
  post: {
    timestampYear: 'y',
    timestampMonth: 'm',
    timestampWeek: 'w',
    timestampDays: 'd',
    timestampHour: 'h',
    timestampSecond: 's',
    deletePost: 'Verwijder bericht',
    editPost: 'Bewerk bericht',
    reportPost: 'Rapporteer bericht',
    areYouSure: 'Weet je zeker dat je je bericht wilt verwijderen?',
    reportingSoon: 'Rapportage is nog niet beschikbaar. Kom later nog eens terug.',
    beingProcessed: 'Deze video wordt verwerkt, kom later terug.'
  },
  billing: {
    billing: 'Facturering',
    settings: 'Instellingen',
    history: 'Geschiedenis',
    billingInformation: 'Factuurgegevens',
    paymentMethod: 'Betalingswijze',
    addPaymentMethod: 'Betaalmethode toevoegen',
    youNeedToAddMethod: 'Je moet een betaalmethode toevoegen',
    forYourPurches: 'Je wordt doorgestuurd naar onze web app om je betaalmethode toe te voegen.',
    goToWebApp: 'Naar web-app',
    exp: 'Exp',
    removingCard: 'Deze kaart wordt verwijderd',
    sureToRemove: 'Weet u zeker dat u **** {{last4}} wilt verwijderen?',
    noPaymentsYet: 'Nog geen betalingen.',
    processedPaymentsHere: 'Hier zie je de lijst van de verwerkte betalingen.',
    shoutoutTo: 'Shoutout naar {{name}}',
    connectWith: 'Een-op-een verbinding maken met {{name}}',
    connectRefused: 'Een-op-een verbinding geweigerd door {{name}}',
    connectCanceledBy: 'Een-op-een verbinding geweigerd door {{name}}',
    termsAndConditions:
      'Volgens de algemene voorwaarden ga ik ermee akkoord dat het bovenstaande bedrag in rekening wordt gebracht bij de p4p-bevestiging',
    swipeRightToPurchase: 'Veeg naar rechts om te kopen',
    subscription: 'Abonneer je op {{name}}',
    purchase: 'Koop'
  },
  revenueTarget: {
    none: 'Geen',
    oneThousand: 'Tot $ 1.000',
    fiveThousand: 'Tot $ 5.000',
    tenThousand: 'Tot $ 10.000',
    hundredThousand: 'Tot $ 100.000',
    oneMillion: 'Tot $ 1.000.000',
    moreThanMillion: 'Meer dan $ 1.000.000'
  },
  forgotPassword: {
    recoveryEmailSent: 'Herstel-e-mail verzonden',
    checkYourInbox:
      'Controleer je inbox (en spamfolders) om de instructies te vinden en te volgen om het wachtwoord opnieuw in te stellen.',
    backToLogin: 'Terug naar inloggen',
    passwordReset: 'Wachtwoord opnieuw instellen',
    enterEmail:
      'Voer het e-mailadres in dat bij je account hoort, en wij sturen de instructies voor het herstel van het wachtwoord.',
    sendRecovery: 'Herstel-e-mail verzenden',
    checkEmail: 'Controleer uw e-mailadres',
    noAccount: 'Er is geen account gekoppeld',
    anotherAddress: 'Probeer een ander adres.',
    tryAnother: 'Probeer een ander e-mailadres',
    createNewPassword: 'Nieuw wachtwoord aanmaken',
    doesntMatch: 'Komt niet overeen',
    newPassword: 'Nieuw wachtwoord',
    resetPassword: 'Wachtwoord opnieuw instellen',
    passwordRule1: 'Het nieuwe wachtwoord moet anders zijn dan het vorige.',
    passwordRule2: 'Tenminste 8 karakters - hoe meer karakters, hoe beter.',
    passwordRule3: 'Combinatie van hoofdletters en kleine letters.',
    passwordRule4: 'Combinatie van letters en cijfers.',
    passwordRule5: 'Tenminste één speciaal teken, bijvoorbeeld ! @ # ?'
  },
  getTheApp: {
    header: 'Download de playaz4playaz APP voor je smartphone',
    setupAccount: 'Download de playaz4playaz APP voor je smartphone om je account in te stellen.'
  },
  share: {
    repost: 'Opnieuw plaatsen',
    copyLink: 'Link kopiëren',
    viaMessage: 'Delen via bericht',
    toFb: 'Delen op Facebook',
    toInst: 'Delen op Instagram',
    toTwit: 'Delen op Twitter',
    toWhapp: 'Delen op WhatsApp',
    toTelg: 'Delen op Telegram',
    viaEmail: 'Delen via e-mail'
  },
  verification: {
    verifyProfile: 'Link naar je Twitter profiel',
    verifyProfile2: 'Profiel verifiëren',
    accountNeedsVerification:
      'Je account moet worden geverifieerd. Neem een Selfie met je ID naast je gezicht. Dat kun je later doen vanuit het Profiel.',
    needVerification:
      'Je account moet worden geverifieerd om deel te nemen aan de één-op-één gesprekken.',
    yourProfileVerified: 'Je profiel is geverifieerd',
    verificationRequested: 'Verificatie gevraagd',
    beingVerified:
      'Bedankt voor het voltooien van de verificatie. Nu kun je starten met het een-op-een gesprek.',
    profileVerifiedDescription:
      'Bedankt voor het voltooien van de verificatie. Nu kun je starten met het een-op-een gesprek.'
  },
  events: {
    shoutouts: 'Shoutouts',
    livescore: 'Livescore',
    pictures: "Foto's",
    stats: 'Stats',
    noShoutouts: 'Nog geen shoutouts voor dit evenement',
    addShoutout: 'Stuur nu een shoutout om de eerste te zijn!'
  },
  games: {
    ht: 'Rust',
    ft: 'Eindtijd\n',
    matchday: 'Matchday {{round}}',
    roundOf16: 'Ronde van 16',
    quarterFinal: 'Kwartfinale',
    semiFinal: 'Halve finale',
    playOff: 'Uitspelen',
    playoffFinal: 'Playoff finale',
    final: 'Finale',
    preSeason: 'Voorseizoen',
    playOffSemiFinal: 'Playoff halve finale',
    wantToShoutout: 'Wil je schreeuwen?'
  },
  permissions: {
    permissionsBlocked: 'Machtigingen geblokkeerd',
    goToYourSettings: 'Ga naar je instellingen en schakel {{permission}} in.',
    openSettings: 'Instellingen openen',
    camera: 'Camera',
    microphone: 'Microfoon',
    gallery: 'Galerij'
  },
  store: {
    suggestedItems: 'Voorgestelde artikelen',
    liked: 'Ik vond  leuk.',
    merchandise: 'Koopwaar',
    tickets: 'Kaartjes',
    fromSubscribed: 'Van ingeschreven atleten',
    productDetails: 'Productgegevens',
    selectSize: 'Selecteer maat',
    selectStock: 'Selecteer type',
    seeSizeGuide: 'Zie maattabel',
    currentBid: 'Huidig bod',
    placeBid: 'Plaats bod',
    likedProducts: 'Geliefde producten',
    noLiked: 'Nog geen favoriete producten',
    addToCart: 'In winkelwagen',
    cart: 'Winkelwagen',
    totalCost: 'Totale kosten: ',
    checkout: 'Kassa',
    orderSuccessful: 'Succesvolle bestelling',
    size: 'Maat',
    price: 'Prijs',
    proceedToPayment: 'Doorgaan naar betaling',
    sizeWithDesc: '{{size}} grootte',
    clearAll: 'Alles wissen'
  },
  goLive: {
    onlineCount: '{{onlineCount}} abonnees online',
    onlineCountFan: '{{onlineCount}} volgers online',
    watchingCount: '{{watchingCount}} kijken',
    youAreLive: 'Je bent live!',
    streamIsFinished: 'De stream is klaar.',
    live: 'LIVE',
    end: 'Einde',
    comment: 'Opmerking',
    tapForGoLive: 'Tikken voor live gaan'
  },
  subscribe: {
    monthly: 'Maandelijkse',
    annual: 'Jaarlijks',
    off: '{{amount}} % KORTING',
    upToOff: 'TOT {{amount}}% KORTING',
    athletesAndTeams: 'Atleten en teams',
    subscribeFor: 'Abonneren voor <strong>{{bedrag}}/maand</strong>',
    subscriptionSummary: 'Overzicht abonnementen',
    introductoryOffer: 'Introductieaanbieding',
    annualDiscount: 'Betaal 10 maanden voor 12 met Jaarkorting',
    noResults: 'Geen resultaten gevonden met de overeenkomende criteria',
    teamFan: '{{team}} fan?',
    subscribeForTeam:
      'Schrijf je in voor alle teamatleten vanaf <strong> {{amount}} </strong> /maand',
    seeAllAthletes: 'Bekijk alle {{number}} atleten',
    subscribeModalTitle: 'Abonneer je op je favoriete atleten en teams',
    subscribeModalDesc:
      'Geniet van de exclusieve content van de atleten en teams. Abonneer je op de teams en krijg toegang tot alle spelers vanaf $5,99.',
    athletesToSubscribe: 'Atleten om in te schrijven',
    numberAthletes: '{{amount}} atleten',
    cancelSubscription: 'Abonnement annuleren',
    daysLeftInPeriod: '{{amount}} resterende dagen in huidige periode',
    sureToCancel: 'Weet je zeker dat je je abonnement wilt opzeggen?',
    bundleSquad: '{{name}} ploeg',
    remindMeLater: 'Herinner me later'
  },
  americanFootball: {
    quarterback: 'Quarterback',
    runningBack: 'Terugrennen',
    wideReceiver: 'Wide ontvanger',
    tightEnd: 'Strak einde',
    leftGuard: 'Linker Guard',
    rightGuard: 'Rechter bewaker',
    center: 'Midden',
    leftTackle: 'Linker tackle',
    rightTackle: 'Rechter tackle',
    noseTackle: 'Neus Tackle',
    defensiveTackles: 'Verdedigende tackles',
    offensiveTackles: 'Aanvallende tackles',
    offensiveLineman: 'Aanvallende lijnman',
    middleLineBacker: 'Middenlijn Ruggensteun',
    outsideLineBacker: 'Buitenlijnverdediger',
    defensiveBack: 'Verdedigende back',
    flanker: 'Flankaanvaller',
    splitEnd: 'Gespleten einde',
    kicker: 'Kicker',
    punter: 'Punter',
    cornerback: 'Hoekback',
    safety: 'Veiligheid',
    defensiveEnd: 'Verdedigend einde',
    runningBackHalfback: 'Teruglopend (halfback)',
    runningBackFullback: 'Rechts Full-back'
  },
  baseball: {
    centerFielder: 'Middenvelder',
    pitcher: 'Kruik',
    catcher: 'Vanger',
    baseman: 'Honkman',
    shortstop: 'Korte stop',
    leftFielder: 'Linksvelder',
    rightFielder: 'Rechtsvelder',
    firstBaseman: 'Eerste honkman',
    secondBaseman: 'Tweede honkman',
    thirdBaseman: 'Derde honkman',
    designatedHitter: 'Aangewezen slagman'
  },
  basketball: {
    pointGuard: 'Punt Guard',
    shootingGuard: 'Scherpschutter',
    smallForward: 'Kleine Voorwaartse',
    powerForward: 'Kracht vooruit',
    center: 'Midden',
    comboGuard: 'Combo Guard',
    wingGuard: 'Vleugelwacht',
    pointForward: 'Punt voorwaarts',
    comboForward: 'Combo Voorwaarts'
  },
  cricket: {
    captain: 'Kapitein',
    wicketkeeper: 'Wicketkeeper',
    slip: 'Slip',
    gully: 'Geul',
    point: 'Punt',
    cover: 'Omslag',
    thirdMan: 'Derde man',
    fineLeg: 'Fijn been',
    midWicket: 'Middenvelder Wicket',
    midOff: 'Middenvelder Uit',
    squareLeg: 'Vierkant been'
  },
  soccer: {
    goalkeeper: 'Doelman',
    striker: 'Opvaller',
    centerbackStopper: 'Middenback (stopper)',
    centerbackSweeper: 'Middenback (veegmachine)',
    centerbackQuarterBack: 'Middenback (quarter-back)',
    rightFullback: 'Rechts Full-back',
    leftFullback: 'Linker Full-back',
    centerForward: 'Midden voor',
    wingers: 'Vleugelspelers',
    leftMid: 'Linker middenvelder',
    wideMid: 'Brede middenvelder',
    rightMid: 'Rechter middenvelder',
    centerMid: 'Middenvelder',
    attackingMid: 'Aanvallende middenvelder',
    defensiveMid: 'Verdedigende middenvelder',
    defensiveMidBallWinner: 'Verdedigende middenvelder (bal-winner)',
    defensiveMidDeepLyingPlaymaker: 'Verdedigende middenvelder (diepgaande positiespeler)',
    boxToBoxMid: 'Box-to-box Middenvelder',
    wingback: 'Vleugelspeler/Vleugelspeler',
    false9: 'Vals 9',
    raumdeuter: 'Raumdeuter',
    forward: 'Vooruit'
  },
  tennis: {
    oneUp: 'Een omhoog',
    oneBack: 'Een-rug'
  },
  handball: {
    goalkeeper: 'Doelman',
    leftBack: 'Linksachter',
    centerBack: 'Middenachter/midden',
    rightBack: 'Rechtsachter',
    leftWinger: 'Linkervleugelspeler',
    centerForward: 'Middenvoor/Pivot/Cirkelrunner',
    rightWinger: 'Rechtse vleugelspeler',
    farRight: 'Extreem rechts',
    halfRight: 'Half rechts',
    backCenter: 'Terug Midden',
    frontCenter: 'Middenvoor'
  },
  iceHockey: {
    leftDefenseman: 'Linkerverdediger',
    goaltender: 'Doelman/voetbalvrouw',
    rightDefenseman: 'Rechterverdediger',
    leftWinger: 'Linkervleugelspeler',
    center: 'Midden',
    rightWinger: 'Rechtse vleugelspeler'
  },
  lacrosse: {
    attackmen: 'Aanvallers',
    mid: 'Middenvelder',
    defensemen: 'Verdedigers',
    goalkeeper: 'Doelman'
  },
  polo: {
    lowWingLeftWing: 'Lage vleugel/linkervleugel',
    lowWingRightWing: 'Lage vleugel/Rechtervleugel',
    centerHoleSet: 'Midden/gatset',
    topWingLeftFlat: 'Bovenvleugel/Links plat',
    topWingRightFlat: 'Bovenste vleugel/rechts plat',
    point: 'Punt',
    cornerPost: 'Hoek/Paal',
    middleDefense: 'Midden/Verdediging',
    topDefense: 'Top verdediging'
  },
  rowing: {
    coxswain: 'Stuurman',
    rower: 'Roeier'
  },
  softball: {
    pitcher: 'Kruik',
    catcher: 'Vanger',
    firstBaseman: 'Eerste honkman',
    secondBaseman: 'Tweede honkman',
    shortstop: 'Korte stop',
    thirdBaseman: 'Derde honkman',
    leftFielder: 'Linksvelder',
    centerFielder: 'Middenvelder',
    rightFielder: 'Rechtsvelder'
  },
  rugby: {
    looseheadProp: 'Strakke kop Prop',
    hooker: 'Hooker',
    tightheadProp: 'Strakke kop Prop',
    lock2ndRow: 'Slot/2e rij',
    blindSideFlanker: 'Flankaanvaller',
    openSideFlanker: 'Flankaanvaller',
    number8: 'Nummer 8',
    scrumHalf: 'Scrum Helft',
    flyHalf: 'Vrije helft',
    leftWing: 'Linkervleugel',
    insideCenter: 'Binnen Centrum',
    outsideCenter: 'Buiten centrum',
    rightWing: 'Rechts',
    fullback: 'Fullback'
  },
  volleyball: {
    setter: 'Setter',
    outsideHitter: 'Buiten slagman',
    middleBlocker: 'Midden Blokkeerder',
    libero: 'Libero',
    oppositeHitter: 'Tegenovergestelde slagman'
  },
  stories: {
    subscribeTo: 'Abonneer u om toegang te krijgen tot meer verhalen van {{name}}'
  },
  reports: {
    descriptionPlaceholder: 'Beschrijf je reden...',
    reportingPost: "{{name}}'s bericht rapporteren",
    reportingShoutout: 'Het verhaal van {{name}} melden',
    reportingStory: 'Het verhaal van {{name}} melden',
    report: 'Rapporteer'
  },
  error: {
    noNetwork: 'No network connection',
    somethingWentWrong: 'Er is iets misgegaan!',
    pleaseTryAgainLater: 'Probeer het later nog eens.'
  },
  requestShoutout: {
    discardChanges: 'Discard changes?',
    selectAthlete: 'Select Athlete',
    newRequest: 'New Request',
    requestAShoutout: 'Request a Shoutout',
    itsMine: "It's mine",
    forSomeoneElse: 'For someone else',
    whatIsYourName: 'What is your name?',
    introduction: 'Introduce yourself',
    selectOcassion: 'Select occasion/reason',
    birthday: 'Birthday',
    anniversary: 'Anniversary',
    motivational: 'Motivational',
    mentorship: 'Mentorship',
    gender: 'Gender',
    addInstruction: 'Add instruction (what you would like them to say)',
    deliveryInfo: 'Delivery info',
    standard: 'Standard',
    videoDelivered: 'Video will be delivered in {{day}} days',
    requestSent: 'Your request has been sent!',
    requestConfirmation:
      "We've just sent out your Shoutout request to {{athlete}}. While completion time is up to {{day}} days, we're optimistic it might be done even sooner.",
    whoThisFor: 'Who is this for?',
    standard: 'Standard ({{price}})',
    bookNow: 'Book now',
    backToShoutout: 'Back to Shoutout',
    maximum18Chars: 'Maximum 18 characters',
    maximum200Chars: 'Maximum 200 characters',
    youCanAdd18Chars: 'You can type up to 18 characters',
    youCanAdd200Chars: 'You can type up to 200 characters'
  },
  yourRequests: {
    view: 'View',
    yourRequests: 'Your Requests',
    myShoutoutRequests: 'My Shoutout Requests',
    shoutoutRequestsFromFans: 'Shoutout Requests from Fans',
    face2faceRequests: 'Face2face Requests',
    all: 'All',
    pending: 'Pending',
    completed: 'Completed',
    unfulfilled: 'Unfulfilled',
    fromAthletes: 'From Athletes',
    fromFans: 'From Fans',
    dayLeft: '{{dayLeft}} Day left',
    daysLeft: '{{dayLeft}} Days left',
    fulfilledOn: 'Fulfilled on {{date}}',
    unfulfilledOn: 'Unfulfilled on {{date}}',
    decline: 'Decline',
    startRecording: 'Start Recording',
    record: 'Record',
    tapForRecording: 'Tap for recording',
    send: 'Send',
    completeTheRequest: 'Complete the Request',
    discardChanges: 'Discard changes?',
    confirm: 'Confirm',
    cancel: 'Cancel',
    awesome: 'Awesome!',
    shoutoutSuccessfullySent: 'Your Shoutout has been successfully sent!',
    declineTheRequest: 'Decline the Request',
    busyConsiderToProfit:
      'We understand you are busy, please consider to profit from your brand on the next fan request.'
  },
  shoutoutsVideoGallery: {
    fromMe: 'From Me',
    fromFellowAthletes: 'From Fellow Athletes',
    for: 'For {{name}}'
  },
  letsChatSports: {
    startChat: 'Start Chat',
    writeTopic: 'Write a topic'
  }
};
